import { FiInfo } from "react-icons/fi";
import AddIcon from "../Assets/CirclesEnterpriseDashboard.svg";
import { useNavigate } from "react-router-dom";

export default function EmptyStateFornitori() {

    const navigate = useNavigate();

    return (
        <div className="w-full flex flex-col p-6">
            {/* Header */}
            <div className="w-full flex justify-between items-start">
                <div>
                    <p className="text-lg font-semibold">A2A spa</p>
                    <p className="text-sm text-gray-500">FCLZ00001A</p>
                </div>

                <button className="flex items-center gap-2 border border-gray-400 px-4 py-1 rounded text-sm text-gray-800 hover:shadow-md transition-shadow">
                    <FiInfo className="w-4 h-4" />
                    TERMINI & CONDIZIONI
                </button>
            </div>

            {/* Icona centrale + CTA */}
            <div className="flex flex-col items-center gap-4 text-center">
                <img
                    src={AddIcon}
                    alt="Aggiungi fornitori"
                    className="w-60 h-60 object-contain pointer-events-none select-none"
                />

                <button
                    onClick={() => navigate("/addnewfornitore")}
                    className="px-6 py-2 border border-gray-400 rounded text-sm font-medium text-gray-800 hover:shadow-md transition-shadow">
                    AGGIUNGI
                </button>

                <p className="max-w-md text-sm text-gray-600 mt-4">
                    Seleziona “Aggiungi” per cominciare a caricare i dati dei tuoi singoli
                    fornitori o una loro lista completa.
                </p>
            </div>
        </div>
    );
}
